// extracted by mini-css-extract-plugin
export default {"dropdown":"pharmacySearch_dropdown__EYNjn"};